<template>
  <div>
    <slot :article-promotions="articlePromotions" />
  </div>
</template>

<script setup lang="ts">
import type { Price } from '@expert/types';

interface Props {
  articleId: string;
  price: Price;
  limit?: number;
}

const props = withDefaults(defineProps<Props>(), {
  limit: 0,
});

const articlePromotions: ComputedRef<Array<ArticlePromotion>> = computed(() => {
  const promotions = getPromotionsForArticle(props.articleId, props.price);
  if (props.limit > 0) {
    return promotions.slice(0, props.limit);
  }
  return promotions;
})
</script>

<style scoped lang="postcss"></style>
